
import { Component, OnInit, inject } from '@angular/core';
import {
	LanguageService,
	PageService,
	PageLoaderService,
	NotificationService,
	AppLanguage,
	AppBaseComponent
} from '@aston/foundation';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { frLocale } from '@aston/foundation';
import { defineLocale, enGbLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { takeUntil, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

import { AuthenticationService } from './authentication-module/services/authentication.service';
import * as ContactFormStoreSelectors from './root-store/contact-form-store/selectors';
import { WebSocketService } from './shared-module/services/websocket.service';
import * as RoutesDefinitions from './routes-definitions';
import { AppConfiguration } from './app.configuration';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	standalone: false
})
export class AppComponent extends AppBaseComponent implements OnInit {
	private store = inject(Store);
	protected ws = inject(WebSocketService);
	private bsLocaleService = inject(BsLocaleService);
	private tooltipConfig = inject(NgbTooltipConfig);

	isContactFormOpened$ = this.store.select(ContactFormStoreSelectors.selectIsOpened);
	assetsPath = '';

	constructor() {
		const config = inject(AppConfiguration);
		const translateService = inject(TranslateService);
		const languageService = inject(LanguageService);
		const pageService = inject(PageService);
		const notificationService = inject(NotificationService);
		const pageLoaderService = inject(PageLoaderService);
		const route = inject(ActivatedRoute);
		const router = inject(Router);
		const authenticationService = inject(AuthenticationService);

		super(translateService, languageService, pageService, notificationService, pageLoaderService, route, router);

		translateService.addLangs(Object.values(AppLanguage));

		defineLocale(AppLanguage.FR, frLocale);
		defineLocale(AppLanguage.EN, enGbLocale);

		// TODO: Find a cleaner way to do this
		// when the user come back, try to restore its auth state
		// but avoid doing this on auth callback page.
		// cf https://github.com/damienbod/angular-auth-oidc-client/issues/483
		if (!window.location.pathname.includes(RoutesDefinitions.getLoginCallbackFullPath())
			&& !window.location.pathname.includes(RoutesDefinitions.getLoginCallbackFullPath()))
		{
			authenticationService.getIsAuthorized().pipe(
				tap(auth => auth && this.ws.connect()),
				takeUntil(this.destroySubscriptions$),
			).subscribe();
		}

		languageService.language$.subscribe(current => {
			this.bsLocaleService.use(current);
		});

		this.assetsPath = config.appRootUrl;

		// Configure tooltips globally
		this.tooltipConfig.animation = false;
	}

}
